import { useEffect, useState } from 'react'
import { header } from '../../portfolio'
import Navbar from '../Navbar/Navbar'
import { Avatar } from 'primereact/avatar';
import './Header.css'

const Header = () => {
  const { homepage, title } = header
  const [scrolled, setScrolled] = useState(false)
  const [scrollProgress, setScrollProgress] = useState(0)

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 60)
      const docHeight = document.documentElement.scrollHeight - window.innerHeight
      setScrollProgress(docHeight > 0 ? (window.scrollY / docHeight) * 100 : 0)
    }
    window.addEventListener('scroll', onScroll, { passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  return (
    <div className={`header-wrapper${scrolled ? ' header-wrapper--scrolled' : ''}`}>
      <div className='header__progress-bar' style={{ width: `${scrollProgress}%` }} />
      <header className='header center'>
        <div className='avatar_title'>
          <Avatar image="/img/profile.jpg" size="xlarge" shape="circle" style={{ width: '44px', height: '44px' }} />
          <h3>
            {homepage ? (
              <a href="#" className='link'>
                {title}
              </a>
            ) : (
              title
            )}
          </h3>
        </div>
        <Navbar />
      </header>
    </div>
  )
}

export default Header
